function SeparacionSecciones(){
    return(
        <div className="separacion">
            <div className="linea-izquierda"></div>
            <div className="logo-separacion">
                <img src="https://hermanos-jota-ei35.onrender.com/img/logooriginal.svg" alt="Logo color marrón"/>
            </div>
            <div className="linea-derecha"></div>
        </div>
    )
}

export default SeparacionSecciones